import { render } from "./employee-modal.vue?vue&type=template&id=1ea1ec1a&scoped=true"
import script from "./employee-modal.vue?vue&type=script&lang=js"
export * from "./employee-modal.vue?vue&type=script&lang=js"

import "./employee-modal.vue?vue&type=style&index=0&id=1ea1ec1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea1ec1a"]])

export default __exports__